import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService {

public http = inject(HttpClient);


  public getBaseInfo<T>(url: string) {
    return this.http.get<T>(url);
  }

  public downloadRequest(url: string): Observable<HttpResponse<Blob>> {
    return this.http.get(url,
      {
        responseType: 'blob',
      observe: 'response'
    });
  }
  
  public getById(url: string) {
    return this.http.get<any>(url)
  }

}
